<template>
  <div class="attendanceRecord">
    <el-col class="userinfoList infoPub" style="width: 990px">
      <div class="exhContent">
        <!-- 搜索组件 -->
<!--        <search-bar-->
<!--          :selectType="broadClass"-->
<!--          :searchInputPlc="searchInputPlc"-->
<!--          :searchSelectPlc="searchSelectPlc"-->
<!--          @changeExhibitionState="getChangeData"-->
<!--          @toSearch="search"-->
<!--          :isExport="true"-->
<!--          isExportFlag = "3"-->
<!--        ></search-bar>-->
        <div class="search-div">
        <el-form>
          <el-form-item>
            <el-select
                clearable
                style="width:263px;background:#fff;border: 1px solid #e6e6e6;margin-right:10px;border-radius: 5px; "
                v-model="exhibitionState"
                placeholder="展会状态">
              <el-option
                  v-for="item in ExhIndexType"
                  :key="item.type"
                  :label="item.name"
                  :value="item.type"></el-option>
            </el-select>
            <el-input
                placeholder="直播间名称/招聘会名称"
                v-model="exhName"
                class="input-with-select"
                style="margin-right:10px;border-radius: 5px;width: 561px;"
            >
            </el-input>
            <el-button
                class="searchBtn"
                @click.native="search"
                style="width: 100px;background-color: #0071ff;border-radius: 5px;border: none;"
            >
              <span style="color: #fff;font-size: 16px;">搜索</span>
            </el-button>
          </el-form-item>
        </el-form>
        </div>



        <!-- table -->
        <pub-table :columns="columns" :tableData="attendanceRecordData" :loading="loading" :ticketMan="ticketMan">
          <template v-slot:action="dataList">
              <el-tooltip class="item" effect="dark" :content="language.playbacknotes" placement="top">
                <el-button
                  size="mini"
                  v-if="dataList.dataList.exh_bstate != 4"
                  @click="handlePlayback(dataList.dataList)"
                  style="background-color: #005bcd;font-size: 16px;border: none;outline: none;color: #FFFFFF;border-radius: 5px;">
                  {{language.playback}}
                </el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="dataList.dataList.broadcast_type == '1' ? language.forumCompanynotes : language.talkCompanynotes" placement="top">
                <el-button
                  v-if="dataList.dataList.exh_bstate != 4"
                  @click="handleTakle(dataList.dataList)"
                  size="mini"
                  style="background-color: #f47900;font-size: 16px;border: none;outline: none;color: #FFFFFF;border-radius: 5px;">
                  面试人员列表
                </el-button>
              </el-tooltip>
          </template>
        </pub-table>
        <!-- page -->
        <table-page
          :pageSize="pageSize"
          :layout="layout"
          :pageTotal="pageTotal"
          :currentPage="currentPage"
          @pageChange="handlePageChange"
        ></table-page>
      </div>
    </el-col>
    <drag-dialog
      :show.sync="dialogVisible"
      :choose="choose"
      :language="language"
      :columns="columnCz"
      :width="width"
      :title="outerTitle"
      :fn="fn"
      :inter_page="inter_page"
      @select-cz-info="handleCzInfo"
      :initCont="initCont"
    >
      <el-dialog
        class="dialog_children"
        width="700px"
        top="30vh"
        :title="appendTitle"
        :visible.sync="innerVisible"
        append-to-body>
        <el-table
          style="width: 100%;margin-top: 20px"
          :data="tableData"
          v-loading="innerLoading"
          :header-cell-style="setHeraderStyle"
        >
          <el-table-column
            v-for="(item,index) in innerColumn"
            :key="index"
            :label="item.title"
            :width="item.width"
            :prop="item.key">
            <template #default="{row}" v-if="item.key == 'type'">
              {{row.type | stateText(LiveStateType)}}
            </template>
            <template #default="{row}" v-else>
            {{row.truetime | date("datetime")}}
            </template>
          </el-table-column>
          <template slot="empty">
            {{empty}}
          </template>
        </el-table>
        <pagination
          v-show="innerTotal > 0"
          style="float: right;margin-top: 10px"
          :total="innerTotal"
          :page.sync="currentPageAppend"
          :limit.sync="numberPageAppend"
          @pagination="getPagination"
        />
      </el-dialog>
    </drag-dialog>

    <appList
      :title="appTitle"
      :dialogVisible="listshow"
      :roomid="broadcast_id"
      @handleclose="handleclose"
    >
    </appList>
  </div>
</template>
<script>
  import {videoUrl} from "../../../common/url";
  import Cookie from "../../../common/cookie"
import { language } from "../../../language/get";
import { attendanceRecord, getBroadcastClass } from "../../../api/btManage";
import searchBar from "../components/searchbar/searchbar";
import pubTable from "../components/table/table";
import tablePage from "../components/tablepage/tablepage";
import dragDialog from "../../../components/DragDialog/index";
import {LiveStateType} from "../../../common/constant/room";
import {getLiveTime, callbackPlatVodio} from "../../../api/forum";
import pagination from "../../../components/Pagination/pagination";
import {mapGetters} from "vuex";
import {isEmpty} from "../../../common/validate";
import {stateEnum} from "./enum";
import appList from "../components/appoint/index";
  import {ExhIndexType} from "@/common/constant/exhibition";
const pubLanguage = language();

const columnsBack = [
  {
    title: pubLanguage.date,
    key: "time",
    width: "370"
  },
  {
    title: pubLanguage.operation,
    key: "action",
    width: '140'
  }
] //回放

const columnComList = [
  {
    title: pubLanguage.username,
    key: "turename",
    width: "110"
  },
  {
    title: pubLanguage.contact,
    key: "tel",
    width: "135"
  },
  {
    title: pubLanguage.companyName,
    key: "company",
    width: "320"
  },
  {
    title: pubLanguage.operation,
    key: "action",
    // width: ''
  }
] //洽谈公司列表


const columnsAppend = [
  {
    title: pubLanguage.state,
    key: "type",
    width: "150"
  },
  {
    title: pubLanguage.time,
    key: "truetime"
  }
] //嵌套

export default {
  components: {
    appList,
    searchBar,
    pubTable,
    tablePage,
    dragDialog,
    pagination
  },
  computed: {
    ...mapGetters(["token"])
  },
  data() {
    return {
      inter_page:true,
      exhName:"",
      exhibitionState:"",
      ExhIndexType,
      ticketMan:true,
      broadcast_id: '',
      appTitle: '',
      choose: '',
      language: pubLanguage,
      listshow: false,
      dialogVisible: false,
      innerVisible: false, //嵌套弹窗
      innerLoading: false,
      loading:true,
      lan: Cookie.get("lang"),
      stateEnum,
      //page
      pageTotal: 0,
      pageSize: 6,
      currentPage: 1,
      layout: "prev, pager, next, jumper",
      //搜索相关
      searchInputPlc: pubLanguage.studioFairName,
      searchSelectPlc: pubLanguage.classification,
      searchData: null,
      broadClass: [],
      //table 表头
      columns: [
        {
          title: pubLanguage.studioName,
          key: "broadcast_name",
          width: "330"
        },
        {
          title: pubLanguage.fairName,
          key: "exh_name",
          width: "248"
        },
        {
          title: pubLanguage.recruiter,
          key: "truename",
          width: "120"
        },
        {
          title: pubLanguage.operation,
          key: "action",
          width:'240'
        }
      ],
      attendanceRecordData: [],
      cloneData: [],
      fromData: {
        broadcast_class: "",
        keyword: "",
      },
      //弹窗信息
      initCont: {}, //弹窗初始化内容
      columnCz: [], //参展弹窗,
      appendTitle: "",
      LiveStateType,
      currentPageAppend: 1,
      numberPageAppend: 6,
      tableData: [],
      empty: "",
      innerTotal: 0,
      liveRow: {},
      roomId: null,
      outerTitle: "",
      innerColumn: columnsAppend,
      width: "",
      fn: null
    };
  },
  created() {
    this.broadcastClass();
    this.attendanceRecordList();
  },
  methods: {
    handleclose(e) {
      this.listshow = e;
    },
    //回放
    handlePlayback(data) {
      this.choose="playback";
      this.fn = this.stateEnum.PLAYBACK;
      this.outerTitle = `${this.language.playbackList} - ${data.broadcast_name}`;
      this.initCont = data;
      this.columnCz = columnsBack;
      this.width = "550px";
      this.dialogVisible = true;
    },
    //洽谈公司列表
    handleTakle(data) {
      this.broadcast_id = data.broadcast_id;
      this.appTitle = '招聘列表-'+data.broadcast_name;
      this.handleclose(true);
      /*this.fn = this.stateEnum.COMPANY_LIST;
      this.outerTitle = `${data.broadcast_type == '1' ? this.language.forumCompany:this.language.talkCompany} - ${data.broadcast_name}`;
      this.initCont = data;
      this.columnCz = columnComList;
      this.width = "750px";
      this.dialogVisible = true*/
    },
    getChangeData(state, val) {
      this.fromData.broadcast_class = state;
      this.fromData.keyword = val;
      this.attendanceRecordList();
    },
    search() {
      this.fromData.exh_status = this.exhibitionState;
      this.fromData.keyword = this.exhName;
      this.currentPage = 1;
      this.attendanceRecordList();
    },
    handlePageChange(val) {
      this.currentPage = val;
      this.attendanceRecordList();
    },
    //获取直播间分类
    broadcastClass() {
      getBroadcastClass({exhibition_id:""}).then(res => {
        if (res.type != '1'){
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({message: res.text, offset: height})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }
        const data = res.data;
        if(data){
          data.splice(0,0,{
            broadcast_class_id:"",
            broadcast_class_name:"全部",
            broadcast_class_name_en: "All"
          });
          this.broadClass = data;
        }
      });
    },
    //展会门票列表
    attendanceRecordList() {
      let that = this;
      this.loading = true;
      let data = {
        token: this.$store.state.user.token,
        exh_status: that.fromData.exh_status,
        keyword: that.fromData.keyword,
        currentPage: that.currentPage,
        numberPage: that.pageSize,
      };
      attendanceRecord(data).then(res => {
        if (res.type == "1") {
          let data = res.data;
          if (typeof data == undefined || data == "" || data == null || isEmpty(data)) {
            this.pageTotal = res.datacount;
            this.attendanceRecordData = [];
            return;
          }
          data.forEach(item => {
            if (this.lan == "en") {
              item.broadcast_name = `${(item.broadcast_name_en||item.broadcast_name)||''}`;
              item.exh_name = `${(item.exh_name_en||item.exh_name)||''}`;
              item.exh_begtime = `${item.exh_begtime}`;
              item.exh_endtime = `${item.exh_endtime}`;
            }else{
              item.broadcast_name = `${item.broadcast_name||item.broadcast_name_en}`;
              item.exh_name = `${(item.exh_name||item.exh_name_en)||''}`;
            }
            item.exh_time = `${item.exh_begtime} ${pubLanguage.to} ${item.exh_endtime}`;
          });
          this.pageTotal = parseInt(res.datacount);
          this.attendanceRecordData = data;
        } else {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({message: res.text, offset: height})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }
      });
      this.loading = false;
    },
    setHeraderStyle({ rowIndex }) {
      if (rowIndex === 0) {
        return `background-color: #F2F2F2;
                        color: #424242;
                        padding:7.5px 0;
                        font-size:14px;
                        border-top: 1px solid #e6e6e6 ;
                        border-bottom: 1px solid #e6e6e6 ;
                        font-weight: normal;
                        `;
      }
    },
    //弹窗信息
    handleCzInfo(row, initCont, fn) {
      if (this.stateEnum.COMPANY_LIST == fn) {
        this.appendTitle = `${pubLanguage.see}-${initCont.broadcast_name}-${row.turename}`;
        this.liveRow = row;
        this.roomId = initCont.broadcast_id;
        this.handleInnerData();
        this.innerVisible= true;
        return;
      }
      const props = {
        roomid: initCont.broadcast_id,
        broadcast_playback_id: row.broadcast_playback_id
      };
      window.open(videoUrl(props));
      // window.location.href = videoUrl(props);
      return;
    },
    getPagination(val){
      this.currentPageAppend = val.page;
      this.handleInnerData();
    },
    handleInnerData() {
      this.innerLoading = true;
      const props = {
        token: this.token,
        roomid: this.roomId,
        user_id: this.liveRow.user_id,
        login_type: this.liveRow.login_type,
        currentPage: this.currentPageAppend,
        numberPage: this.numberPageAppend
      }
      getLiveTime(props).then(res => {
        if (res.type != "1"){
          if (this.lan == "ch") {
            this.empty = res.text;
            const height = document.body.clientHeight / 2;
            return this.$message.error({message: res.text, offset: height})
          }
          this.empty = res.text_en;
          this.innerLoading = false;
          return this.$message.error({message: res.text_en, offset: 120})
        }
        if (isEmpty(res.data)) {
          this.empty = "";
          this.innerLoading = false;
          this.innerTotal = 0;
          this.tableData = [];
          return
        }
        this.empty = "";
        this.innerLoading = false;
        this.innerTotal = res.datacount;
        this.tableData = res.data;



      })
    }
  },
  watch: {
    innerVisible() {
      if (!this.innerVisible) {
          this.empty = "";
          this.innerTotal = 0;
          this.tableData = [];
          this.currentPageAppend = 1;
          this.numberPageAppend = 6;
      }
    },
  }
};
</script>
<style scoped>
  .attendanceRecord >>> .tableNode{
    padding: 30px;
    border-radius: 5px;
  }
  .attendanceRecord >>> .tableNode .el-table{
    border: 1px solid #f2f2f2 !important;
    /*min-height: 420px;*/
  }
  .attendanceRecord >>> .el-table th>.cell{
    border-right:none;
  }

  .attendanceRecord >>> .el-pagination .el-pager li{
    width: 30px;
    height: 30px;
    line-height: 30px;
    background:none;
    font-size: 14px;
  }
  .attendanceRecord >>> .el-pagination .btn-next{
    /*width: 30px;*/
    /*height: 30px;*/
    /*line-height: 30px;*/
    background: #FFFFFF;
  }
  .attendanceRecord >>> .el-pagination .btn-prev{
    /*width: 30px;*/
    /*height: 30px;*/
    /*line-height: 30px;*/
    background: #FFFFFF;
  }
  .attendanceRecord >>> .el-pagination .el-input__inner{
    width: 30px;
    height: 30px;
    line-height: 25px;
    margin-top: -15px !important;
  }
  .attendanceRecord >>> .el-pagination .el-pagination__jump{
    width: 25px;
    height: 25px;
    line-height: 25px;
    color: #333333 !important;
  }
  .attendanceRecord >>> .page .tiaozhuan{
    margin-left: 85px !important;
  }
  .attendanceRecord >>> .page{
    margin-left: 0px;
  }
</style>
<style>
  .dialog_children .el-dialog {
    padding: 20px
  }
  .dialog_children .el-dialog__header{
    padding: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #a1a1a1;
  }
  .dialog_children .el-dialog__title {
    font-size: 14px;
    line-height: 14px;
  }
  .dialog_children .el-dialog__body {
    padding: 0;
    padding-bottom: 40px;
  }
  .dialog_children .el-table .cell {
    padding-left: 20px;
  }
  .search-div {
    background: #ffffff;
    height: 40px;
    padding: 10px;
  }
</style>
